{
  "fr": {
    "hangarPlanner": {
      "title": "Planificateur de hangar",
      "lead": "Planifiez le hangar que vous voulez en emplacements (les rôles à couvrir) et déterminez comment y arriver depuis votre hangar actuel : ce que vous gardez, ce que vous melt et quels upgrades et buy-backs utiliser.",
      "createPlan": "Nouveau plan",
      "editPlan": "Modifier le plan",
      "destroyPlan": "Supprimer le plan",
      "confirmDestroy": "Supprimer ce plan ? Votre hangar n'est pas modifié.",
      "more": "Plus",
      "share": "Partager par lien",
      "copyShareLink": "Copier le lien de partage",
      "unshare": "Arrêter le partage",
      "shared": "Partagé",
      "sharedMissing": "Ce plan n'est pas partagé, ou le lien a changé.",
      "addToWishlist": "Ajouter les achats à la liste de souhaits",
      "confirmAddToWishlist": "Ajouter à votre liste de souhaits chaque vaisseau que ce plan doit encore obtenir ?",
      "compareWith": "Comparer avec %{plan}",
      "compareTitle": "%{left} vs. %{right}",
      "slotsCount": {
        "one": "%{count} emplacement",
        "other": "%{count} emplacements"
      },
      "updatedAt": "Mis à jour le %{date}",
      "empty": {
        "title": "Aucun plan pour l'instant",
        "text": "Commencez un plan de zéro, depuis votre hangar, depuis votre liste de souhaits ou en copiant un autre plan."
      },
      "noSlots": "Ce plan n'a pas encore d'emplacement. Ajoutez un emplacement pour chaque rôle que votre hangar doit couvrir.",
      "placeholderRoles": {
        "starter": "Vaisseau du quotidien",
        "cargo": "Cargo",
        "exploration": "Explorateur"
      },
      "useAsFirstSlot": "En faire mon premier emplacement",
      "addSlot": "Ajouter un emplacement",
      "editSlot": "Modifier l'emplacement",
      "removeSlot": "Retirer l'emplacement",
      "confirmRemoveSlot": "Retirer cet emplacement avec ses vaisseaux et ses voies d'obtention ?",
      "openSlotHint": "Aucun vaisseau choisi pour l'instant. Ajoutez-en un, ou plusieurs si vous hésitez.",
      "addShips": "Ajouter des vaisseaux",
      "addCandidates": "Vaisseaux pour %{slot}",
      "addToSlot": "Ajouter à l'emplacement",
      "inSlot": "Dans cet emplacement",
      "choose": "Choisir",
      "removeCandidate": "Retirer le vaisseau",
      "ownedCount": {
        "one": "%{count} dans votre hangar",
        "other": "%{count} dans votre hangar"
      },
      "notOnSale": "non vendu",
      "routes": "Comment les obtenir",
      "addRoute": "Ajouter une voie vers %{ship}",
      "addRouteShort": "Ajouter une voie",
      "editRoute": "Voie vers %{ship}",
      "removeRoute": "Retirer la voie",
      "unresolvedUnits": {
        "one": "%{count} vaisseau n'a pas encore de voie",
        "other": "%{count} vaisseaux n'ont pas encore de voie"
      },
      "routeMustEnd": "La voie doit se terminer sur le %{ship}.",
      "upgradeSteps": "Upgrades",
      "stepNumber": "Upgrade %{number}",
      "addStep": "Ajouter un upgrade",
      "removeStep": "Retirer l'upgrade",
      "sourceMissing": "n'est plus dans votre hangar",
      "melts": "Melts",
      "noMelts": "Aucun vaisseau à melt.",
      "addMelt": "Melt un vaisseau",
      "editMelt": "Modifier le melt",
      "removeMelt": "Garder le vaisseau",
      "estimated": "estimation",
      "free": "Gratuit",
      "unknownPrice": "Inconnu",
      "fields": {
        "name": "Nom",
        "description": "Description",
        "startingCredit": "Crédit boutique",
        "startingCreditInfo": "Crédit boutique que vous avez déjà, en USD.",
        "source": "Partir de",
        "sourcePlan": "Plan à copier",
        "slotLabel": "Rôle",
        "slotLabelPlaceholder": "p. ex. Cargo principal",
        "quantity": "Vaisseaux",
        "startKind": "Commence comme",
        "ownedShip": "Vaisseau de votre hangar",
        "buyback": "Pledge de buy-back",
        "startModel": "Vaisseau",
        "priceOverride": "Prix payé",
        "priceOverrideInfo": "Laissez vide pour utiliser le prix actuel de la boutique, ou saisissez un prix de promotion ou de warbond.",
        "upgradeSource": "Upgrade depuis",
        "ownedUpgrade": "Upgrade dans votre hangar RSI",
        "upgradeTo": "Upgrade vers",
        "meltShip": "Vaisseau à melt",
        "meltValue": "Crédit",
        "meltValueInfo": "Ce que la fonte rapporte. Laissez vide pour utiliser la valeur que RSI donne au pledge, ou le prix boutique du jour si la synchronisation du hangar ne l'a pas lue.",
        "slotDescription": "Description",
        "filters": "Vaisseaux adaptés",
        "filtersInfo": "Le sélecteur de vaisseaux s'ouvre avec ces filtres. Les vaisseaux hors filtres peuvent quand même être ajoutés et sont signalés.",
        "priceFrom": "Prix à partir de",
        "priceTo": "Prix jusqu'à",
        "minCargo": "Cargo minimum",
        "onSaleOnly": "Uniquement les vaisseaux en vente",
        "buybackTokens": "Jetons de rachat",
        "buybackTokensInfo": "Chaque jeton permet de payer un rachat avec du crédit boutique. Sans jeton, un rachat coûte de l'argent frais.",
        "buybackTokensSynced": "Chaque jeton permet de payer un rachat avec du crédit boutique. Votre dernière synchronisation des rachats en a lu %{count} chez RSI ; laissez vide pour utiliser cette valeur.",
        "vatRate": "TVA",
        "vatRateInfo": "La TVA que RSI ajoute au paiement selon ton pays, p. ex. 20 en France. Elle ne s'applique qu'à l'argent neuf ; le crédit boutique l'inclut déjà."
      },
      "sources": {
        "empty": "Un plan vide",
        "hangar": "Mon hangar",
        "wishlist": "Ma liste de souhaits",
        "plan": "Un autre plan"
      },
      "states": {
        "open": "Ouvert",
        "decided": "Décidé",
        "undecided": "Indécis"
      },
      "startKinds": {
        "owned": "Gardé du hangar",
        "store": "Achat en boutique",
        "ingame": "Acheté en jeu",
        "buyback": "Buy-back"
      },
      "upgradeSources": {
        "store": "Boutique",
        "owned_ccu": "Mon hangar RSI",
        "buyback": "Buy-back"
      },
      "vehicleStatuses": {
        "kept": "Gardé",
        "upgraded": "Upgradé",
        "melted": "Melt",
        "unassigned": "Hors plan"
      },
      "changes": {
        "added": "Nouveau",
        "removed": "Parti",
        "more": "Plus",
        "fewer": "Moins",
        "unchanged": "Identique"
      },
      "issues": {
        "missing_price": "%{name} n'a pas de prix connu, le total l'ignore donc.",
        "not_on_sale": "%{name} n'est pas en vente actuellement."
      },
      "summary": {
        "title": "Coûts",
        "spend": "Nouvelles dépenses",
        "meltCredit": "Crédit des melts",
        "startingCredit": "Crédit boutique",
        "net": "Coût net",
        "cashNeeded": "Reste à payer",
        "remainingCredit": "Crédit restant",
        "estimatedMelts": {
          "one": "%{count} estimé",
          "other": "%{count} estimés"
        },
        "openSlots": {
          "one": "%{count} emplacement sans vaisseau",
          "other": "%{count} emplacements sans vaisseau"
        },
        "undecidedSlots": {
          "one": "%{count} emplacement indécis",
          "other": "%{count} emplacements indécis"
        },
        "unresolved": {
          "one": "%{count} vaisseau sans voie",
          "other": "%{count} vaisseaux sans voie"
        },
        "incomplete": "Le total est incomplet",
        "complete": "Chaque vaisseau a une voie et un prix.",
        "buybackCash": "Rachats en argent frais",
        "buybacksWithoutToken": {
          "one": "%{count} rachat sans jeton",
          "other": "%{count} rachats sans jeton"
        },
        "tokensShort": {
          "one": "%{count} rachat utilise un jeton, mais vous en avez %{available}. Le reste compte comme argent frais.",
          "other": "%{count} rachats utilisent un jeton, mais vous en avez %{available}. Le reste compte comme argent frais."
        }
      },
      "comparison": {
        "title": "Comparé à votre hangar",
        "yourShips": "Vos vaisseaux",
        "noShips": "Votre hangar n'a aucun vaisseau.",
        "changes": "Changements",
        "noChanges": "Aucun changement.",
        "toAcquire": "Reste à obtenir",
        "hangar": "Hangar",
        "plan": "Plan",
        "happens": "Ce qui se passe",
        "meltCredit": "%{value} de crédit",
        "leaves": "Quitte votre hangar",
        "notInPlan": "Pas dans le plan",
        "notOwned": "Pas dans votre hangar",
        "lead": "À gauche chaque vaisseau que vous possédez, à droite chaque vaisseau dont le plan a besoin, et entre les deux ce qui se passe.",
        "anotherPlan": "Comparer avec un autre plan",
        "tallies": {
          "kept": {
            "one": "%{count} conservé",
            "other": "%{count} conservés"
          },
          "upgraded": {
            "one": "%{count} amélioré",
            "other": "%{count} améliorés"
          },
          "melted": {
            "one": "%{count} fondu",
            "other": "%{count} fondus"
          },
          "toAcquire": {
            "one": "%{count} reste à obtenir",
            "other": "%{count} restent à obtenir"
          },
          "open": {
            "one": "%{count} emplacement ouvert",
            "other": "%{count} emplacements ouverts"
          }
        },
        "costsTitle": "Ce que ça coûte",
        "flow": {
          "steps": {
            "one": "%{count} amélioration · %{price}",
            "other": "%{count} améliorations · %{price}"
          },
          "shipOf": "vaisseau %{number} sur %{count}",
          "noRoute": "Pas encore de voie",
          "notCounted": "hors du total",
          "noShip": "pas encore de vaisseau",
          "notInPlan": {
            "one": "%{count} vaisseau hors du plan",
            "other": "%{count} vaisseaux hors du plan"
          }
        },
        "changeSides": {
          "in": "Arrive",
          "out": "Part"
        },
        "unchangedCount": {
          "one": "%{count} modèle reste tel quel.",
          "other": "%{count} modèles restent tels quels."
        },
        "after": "Après le plan"
      },
      "metrics": {
        "title": "Statistiques",
        "total": "Vaisseaux",
        "uniqueModelsCount": "Modèles différents",
        "manufacturerCount": "Constructeurs",
        "flightReadyCount": "Prêts à voler",
        "totalCrew": "Équipage",
        "totalCargo": "Cargo (SCU)",
        "totalPledgeValue": "Valeur boutique",
        "largestShip": "Plus grand vaisseau",
        "smallestShip": "Plus petit vaisseau",
        "classifications": "Classifications",
        "sizes": "Tailles",
        "productionStatuses": "Statut de production"
      },
      "drift": {
        "title": "Votre hangar a changé depuis la création de ce plan",
        "missing": {
          "one": "%{count} vaisseau ou pledge utilisé par le plan a disparu.",
          "other": "%{count} vaisseaux ou pledges utilisés par le plan ont disparu."
        },
        "changed": {
          "one": "%{count} vaisseau est maintenant un autre modèle.",
          "other": "%{count} vaisseaux sont maintenant d'autres modèles."
        },
        "added": "Nouveau dans votre hangar : %{ships}",
        "prices": "Les prix ont changé : %{before} lors de la planification, %{now} aujourd'hui.",
        "rebase": "Mettre à jour depuis le hangar"
      },
      "messages": {
        "saved": "Plan enregistré.",
        "saveFailed": "Cela n'a pas fonctionné. Veuillez vérifier votre saisie.",
        "shareCopied": "Lien de partage copié.",
        "unshared": "Le lien de partage ne fonctionne plus.",
        "addedToWishlist": {
          "one": "%{count} vaisseau ajouté à votre liste de souhaits.",
          "other": "%{count} vaisseaux ajoutés à votre liste de souhaits."
        },
        "rebased": "Plan mis à jour depuis votre hangar.",
        "sharingOn": "Le partage est activé. Toute personne disposant du lien peut voir ce plan.",
        "copyFailed": "Le lien n'a pas pu être copié. Copiez-le depuis le champ."
      },
      "filterChips": {
        "priceFrom": "à partir de %{price}",
        "priceTo": "jusqu'à %{price}",
        "cargo": "%{cargo} SCU ou plus",
        "onSale": "en vente"
      },
      "outsideFilters": "hors des filtres de cet emplacement",
      "shareLink": "Lien de partage",
      "specs": {
        "price": "Prix",
        "cargo": "Cargo",
        "crew": "Équipage",
        "size": "Taille",
        "best": "meilleur"
      },
      "readiness": {
        "routed": {
          "one": "%{routed} vaisseau sur %{count} a une voie",
          "other": "%{routed} vaisseaux sur %{count} ont une voie"
        },
        "undecided": "%{slot} est indécis",
        "open": "%{slot} n'a pas de vaisseau",
        "unresolved": {
          "one": "%{slot} : %{count} vaisseau sans voie",
          "other": "%{slot} : %{count} vaisseaux sans voie"
        }
      },
      "meta": {
        "undecided": "%{count} indécis",
        "open": "%{count} ouverts"
      },
      "route": {
        "stillToReach": "Reste à atteindre",
        "yourRoute": "Votre voie",
        "startFirst": "Choisissez d'où vient le vaisseau pour voir la voie.",
        "done": "La voie se termine sur le %{ship}.",
        "startHints": {
          "owned": "Un vaisseau que vous possédez déjà. Si ce n'est pas le %{ship}, ajoutez les améliorations qui le transforment.",
          "buyback": "Un pledge fondu que vous pouvez racheter auprès de RSI. Sans jeton de rachat, il coûte de l'argent frais, pas du crédit boutique.",
          "store": "Un nouveau pledge de la boutique RSI. Partez d'un vaisseau moins cher pour l'améliorer.",
          "ingame": "Acheté en aUEC dans le jeu, il ne coûte donc rien. Un vaisseau acheté en jeu ne peut pas être amélioré, il doit donc s'agir du %{ship} lui-même."
        },
        "noVehicles": "Aucun vaisseau de votre hangar n'est libre pour cette voie.",
        "noBuybacks": "Vous n'avez aucun pledge à racheter. Synchronisez-les depuis votre compte RSI.",
        "pledgeShip": "Vaisseau du pledge",
        "isTarget": "Même vaisseau",
        "holdsTarget": "Le contient",
        "search": "Rechercher",
        "noMatch": "Aucun résultat.",
        "reaches": "Mène au %{ship}",
        "left": {
          "one": "%{count} restante",
          "other": "%{count} restantes"
        },
        "showAll": {
          "one": "Afficher votre %{count} amélioration",
          "other": "Afficher les %{count} améliorations"
        },
        "showFitting": "N'afficher que les améliorations adaptées",
        "unknownTarget": "Vers quel vaisseau elle mène",
        "startCost": "Départ",
        "includesShip": "Contient le %{ship}",
        "cheaperOnly": "Seuls les vaisseaux moins chers que le %{ship} (%{price}) sont proposés, puisque vous les améliorez ensuite.",
        "sort": {
          "price": "Prix",
          "name": "Nom"
        },
        "change": "Changer",
        "from": "Depuis",
        "to": "Vers",
        "todaysPrice": "Prix du jour : %{price}",
        "noStoreShip": "Aucun vaisseau de la boutique ne convient ici.",
        "paidWithCredit": "Crédit boutique",
        "paidWithCash": "Argent neuf",
        "vat": "TVA (%{rate} %)",
        "cashWithVat": "Argent neuf avec TVA",
        "paymentHint": "Le crédit boutique couvre la boutique et les rachats avec jeton. Un rachat sans jeton coûte de l'argent neuf, comme tout ce que ton crédit ne couvre pas.",
        "ownedPaid": "Déjà payée",
        "noHeld": {
          "owned_ccu": "Aucune des améliorations de votre hangar RSI ne part du %{ship}.",
          "buyback": "Aucune de vos améliorations à racheter ne part du %{ship}."
        },
        "direction": {
          "label": "Construire la voie",
          "forward": "Depuis le départ",
          "reverse": "Depuis la cible, à rebours"
        },
        "directionHints": {
          "forward": "Choisissez d'où vient le vaisseau, puis les améliorations qui le mènent au %{ship}.",
          "reverse": "Remontez depuis le %{ship} : choisissez l'amélioration qui y aboutit, puis celle qui aboutit là où elle part. Arrêtez-vous à un vaisseau que vous possédez, pouvez racheter ou acheter."
        },
        "startPending": "Départ encore à choisir",
        "reverseStart": "La voie part du %{ship}.",
        "unknownSource": "Depuis quel vaisseau elle part",
        "noHeldInto": {
          "owned_ccu": "Aucune des améliorations de votre hangar RSI n'aboutit au %{ship}.",
          "buyback": "Aucune de vos améliorations à racheter n'aboutit au %{ship}."
        },
        "upgradeInto": "Amélioration vers le %{ship}",
        "upgradesTo": "vers le %{ship}",
        "inHangar": "Dans votre hangar",
        "buybackAvailable": "Rachat possible",
        "nextStep": "La voie part maintenant du %{ship}. Ajoutez l'amélioration qui y mène, ou choisissez le %{ship} comme départ.",
        "addUpgradeInto": "Ajouter une amélioration vers le %{ship}",
        "startHere": "Partir du %{ship}",
        "shipCard": "Vaisseau",
        "useToken": "Utiliser un jeton de rachat",
        "withToken": "payé avec un jeton",
        "buyTarget": "Acheter le %{ship} lui-même",
        "startShort": {
          "owned": "Hangar",
          "buyback": "Rachat",
          "store": "Boutique",
          "ingame": "En jeu"
        },
        "ingameNoUpgrades": "Un vaisseau acheté en jeu ne prend aucune amélioration. Retirez d'abord les améliorations."
      },
      "meltList": {
        "none": "D'après RSI, aucun de vos vaisseaux ne peut être fondu. Désactivez le filtre pour choisir n'importe quel vaisseau.",
        "credit": "%{value} de crédit",
        "estimate": "%{value} estimé",
        "wholePledge": {
          "one": "fond %{count} objet",
          "other": "fond tout le pledge : %{count} objets"
        },
        "meltableOnly": "Fondables uniquement",
        "notMeltable": "non fondable",
        "notSynced": "non synchronisé",
        "noShips": "Aucun de vos vaisseaux n'est libre pour être fondu.",
        "inPackage": "dans %{name}",
        "contents": "Fondu avec lui",
        "contentsOf": "Fondu avec lui, dans %{name}",
        "unlisted": {
          "one": "%{count} objet de plus que la synchronisation du hangar ne liste pas",
          "other": "%{count} objets de plus que la synchronisation du hangar ne liste pas"
        }
      }
    }
  }
}
